import { useState } from "react";
import "./Message.css";

const MessageData = (props) => {
    const [isOpen, setIsOpen] = useState(false);


    const pgraphst = {
        WebkitLineClamp: "10",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        display: "-webkit-box",
    };

    const mass = props.text && props.text.split("#");

    return (
        <div key={props.id} className={props.className}>
            <div className="message-image">
                <img
                    alt={props.image}
                    src={`${process.env.REACT_APP_BASE_URL}/getimage/messages/${props.image}`}
                />
                <h2>{props.name}</h2>
                <p>{props.title}</p>
            </div>
            <div className="message-text">
                <div style={isOpen ? null : pgraphst}>
                    {mass &&
                        mass.map((item, index) => (
                            <div>
                                {index == 0 ? (
                                    <>
                                        <p style={{ fontWeight: "bold" }}>{item && item}</p>
                                        <br />
                                    </>
                                ) : (
                                    <div>

                                        {mass.length < mass.length + 1 && (
                                            <><p>{item && item}</p>
                                                <br />
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                </div>
                {mass && (
                    <button
                        style={{ marginTop: "0.5rem", display: "" }}
                        type="submit"
                        className="btn btn-success"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {isOpen ? "Read less..." : "Read more..."}
                    </button>
                )}
            </div>
        </div>
    );
};

export default MessageData;
